import React, {useEffect, useState} from "react";
import Spinner from "../../components/Spinner";
import axiosInstance from "../../api";
import CommentCompactView from "./CommentCompactView";
import CreateCommentTile from "./CreateCommentTile";
import {Box} from "@material-ui/core";
import {Link, Pagination} from "@mui/material";

export default function CommentsListViewTile({agentId, leadId,onReturnBack}) {
    const [showSpinner, setShowSpinner] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [searchCriteria, setSearchCriteria] = useState({agentId: agentId, sortBy: 'createdAt', descending:true, ascending: false});
    const [pageCount, setPageCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [commentList, setCommentsList] = useState([]);

    useEffect(() => {
        getAllComments(searchCriteria);
    }, []);

    const getAllComments = (searchCriteria) => {
        setShowSpinner(true);
        if (agentId) getAllAgentComments(searchCriteria);
        if (leadId) getAllLeadComments();

    }

    const getAllLeadComments = () => {
        axiosInstance.get('unauth/leads/getLeadUpdates/'+leadId)
            .then((data) => {
                setPageCount(0);
                let formattedData = data.map(x => {
                    let note = {...x};
                    note.comment = x.notes;
                    return note;
                });
                setCommentsList(formattedData);
            })
            .catch((error) => {
                setErrorMessage('An error occurred. Please try again later.')
            })
            .finally(() => setShowSpinner(false));
    }

    const getAllAgentComments = (searchCriteria) => {
        axiosInstance.post('agents/get-comments-by-critieria', searchCriteria)
            .then((data) => {
                setErrorMessage(null);
                setSearchCriteria(Object.assign({}, data.searchCriteria));
                if (data.totalResultSetSize && !isNaN(data.totalResultSetSize) && !isNaN(data.searchCriteria.numberOfRecordsPerPage)) {
                    setPageCount(Math.ceil(data.totalResultSetSize / data.searchCriteria.numberOfRecordsPerPage));
                }
                if (data && data.resultList && data.resultList.length > 0) {
                    setCommentsList([...data.resultList]);
                } else {
                    setCommentsList([]);
                    setPageCount(0)
                }})
            .catch((error) => {
                setErrorMessage('An error occurred. Please try again later.')
            })
            .finally(() => setShowSpinner(false));
    }

    const onCommentSave = () => {
        getAllComments(searchCriteria)
    }

    const onPageChange = (event, pageNumber) => {
        setCommentsList([]);
        setCurrentPage(pageNumber);
        let newSearchCritera = Object.assign({}, searchCriteria,{pageToShow:pageNumber});
        setSearchCriteria(newSearchCritera);
        getAllComments(newSearchCritera);
    }

    if (showSpinner) return <Spinner/>

    return (<>
        <Box component="span" justifyContent="flex-start" marginLeft="16px" marginTop="8px"
             alignItems="flex-end" display="flex">
            <Link onClick={() => onReturnBack()}>Back</Link>
        </Box>
        <br/>
        <CreateCommentTile agentId={agentId} leadId={leadId} onCommentSave={onCommentSave} />
        <span>Saved Notes:</span>
        {
            commentList && commentList.length > 0 &&
                <section>
                    {commentList.map(x => <CommentCompactView comment={x}/>)}
                    {pageCount > 1 &&
                    <Box component="span" justifyContent="center" alignItems="flex-end" display="flex">
                        <Pagination count={pageCount} color="primary" shape="rounded" onChange={onPageChange}
                                    page={currentPage}/>
                    </Box>}
                </section>
        }
    </>);
}
